module.exports = __webpack_public_path__ + "static/media/Appakara12.517a6d9b.jpeg";